export function EmptyState({ icon: Icon, title, description, action, testId }) {
  return (
    <div
      className="flex flex-col items-center justify-center rounded-lg border border-dashed border-brand-line bg-brand-panel px-6 py-16 text-center"
      data-testid={testId}
    >
      <span className="flex h-14 w-14 items-center justify-center rounded-lg bg-brand-accent/[0.08] text-brand-accent">
        {Icon && <Icon size={26} strokeWidth={2} />}
      </span>
      <h3 className="mt-5 text-lg font-bold text-brand-ink">{title}</h3>
      <p className="mt-1.5 max-w-sm text-sm text-brand-muted">{description}</p>
      {action && <div className="mt-6">{action}</div>}
    </div>
  );
}

export function ErrorState({ title = "No hemos podido cargar esto", description, onRetry, testId }) {
  return (
    <div
      className="flex flex-col items-center justify-center rounded-lg border border-brand-neg/30 bg-brand-neg/[0.05] px-6 py-14 text-center"
      data-testid={testId}
    >
      <h3 className="text-lg font-bold text-brand-ink">{title}</h3>
      <p className="mt-1.5 max-w-sm text-sm text-brand-muted">{description || "Revisa tu conexión e inténtalo otra vez."}</p>
      {onRetry && (
        <button
          onClick={onRetry}
          className="mt-6 rounded-md border border-brand-line bg-brand-panel px-4 py-2 text-sm font-semibold text-brand-ink transition-all duration-150 hover:border-brand-accent hover:text-brand-accent"
          data-testid="error-retry-button"
        >
          Reintentar
        </button>
      )}
    </div>
  );
}

export function RowsSkeleton({ rows = 6 }) {
  return (
    <div className="space-y-3" data-testid="loading-skeleton">
      {Array.from({ length: rows }).map((_, i) => (
        <div key={i} className="flex items-center gap-4 rounded-lg border border-brand-line bg-brand-panel p-4">
          <div className="skeleton h-10 w-10 rounded-md" />
          <div className="flex-1 space-y-2">
            <div className="skeleton h-3.5 w-1/3" />
            <div className="skeleton h-3 w-1/2" />
          </div>
          <div className="skeleton h-6 w-20 rounded-md" />
        </div>
      ))}
    </div>
  );
}

export function CardsSkeleton({ cards = 3 }) {
  return (
    <div className="grid gap-4 md:grid-cols-2 xl:grid-cols-3" data-testid="loading-skeleton">
      {Array.from({ length: cards }).map((_, i) => (
        <div key={i} className="space-y-4 rounded-lg border border-brand-line bg-brand-panel p-6">
          <div className="skeleton h-10 w-10 rounded-md" />
          <div className="skeleton h-4 w-2/3" />
          <div className="skeleton h-3 w-full" />
          <div className="skeleton h-3 w-4/5" />
        </div>
      ))}
    </div>
  );
}
